<template>
  <router-link
    :to="`/company/${cid}/${id}/${isGenderableServices ? 'client-gender' : 'client-service'}`"
    class="client-slider__item"
    :class="{'map-current': ($route.query && $route.query.slide) == id}"
    :id="id"
    :data-index="index"
    :data-hash="'slider-' + index"
  >
    <div class="client-slider__click-wrap">
      <h3 class="client-slider__title">{{ metro }}</h3>
      <div class="client-slider__address">{{ address }}</div>
      <div class="client-slider__address" v-if="distance">
        <img src="../../assets/img/walk.png" class="walk-image">
        <span>{{ distance }} метров пешком</span>
      </div>
      <div class="nav-control">
        <router-link class="btn book-up" :to="`/company/${cid}/${id}/${isGenderableServices ? 'client-gender' : 'client-service'}`">
          Записаться онлайн
        </router-link>
        <button class="btn" @click.prevent="setPath()">Построить маршрут</button>
        <div class="client-slider__time">{{ workingTimeStart }} - {{ workingTimeEnd }}</div>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  name: "OneSalon",
  props: {
    cid: String,
    id: Number,
    index: Number,
    name: String,
    metro: String,
    timeToMetro: String,
    metroHexColor: String,
    address: String,
    employeeCount: Number,
    workingTimeStart: String,
    workingTimeEnd: String,
    isGenderableServices: Boolean,
    position: Array,
    city: String,
    distance: Number,
  },
  methods: {
    setPath () {
      this.$emit('onSetPath')
    },
  },
};
</script>

<style lang="sass">
  .client-slider
    &__wrap
      display: -webkit-flex
      display: -ms-flex
      position: relative
      display: flex
      justify-content: flex-start
      align-items: stretch
      flex-wrap: nowrap
      margin: 0 auto
      max-width: calc(100% - 60px)
      .slick-list
        padding: 10px 15px 10px 0 !important
    &__item
      box-shadow: 0 0 10px rgba(0,0,0,0.1)
      border-radius: 10px
      transition: all .2s
      background-color: #fff
      color: #4d4d4d
      margin: 0 7px
      //min-width: 290px
      &:hover,
      &.map-current
        background-color: #363636
        color: #fff
        .btn
          border: 1px solid #181818
          color: #181818
          background-color: #fff
    &__click-wrap
      text-align: center
      border: 1px solid gainsboro
      border-radius: 5px
      box-shadow: 2px 2px 5px rgba(0,0,0,.3)
      height: 245px
      display: flex !important
      flex-direction: column
    .btn
      display: block
      font-size: 12px
      text-align: center
      padding: 9px 15px
      color: #fff
      border-radius: 8px
      background-color: #363636
      border: 1px solid transparent
      transition: all .2s
      cursor: pointer
      margin: 0 auto
      &.book-up
        margin-bottom: 15px
        font-size: 14px
        line-height: 18px
        font-weight: bold
        width: 100%
      &.is-disabled
        pointer-events: none
      &:hover
        border: 1px solid #181818
        color: #181818
        background-color: #fff
    &__title
      font-size: 14px
      line-height: 18px
      margin-top: 0
      margin-bottom: 5px
      font-weight: bold
    &__address
      font-weight: 500
      margin-top: 0
      margin-bottom: auto
      font-size: 12px
      img
        width: 25px
        display: inline
        vertical-align: top
    &__time
      font-weight: 500
      margin-top: 5px
      margin-bottom: 0
      font-size: 12px
</style>
